var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarStack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 107,
    viewBox: "0 0 89 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 31,
    width: 27,
    height: 76,
    fill: "#122945"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 31,
    fill: "#F75151"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 69,
    width: 27,
    height: 38,
    fill: "#122945"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 45,
    width: 27,
    height: 24,
    fill: "#F75151"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 63,
    width: 27,
    height: 44,
    fill: "#122945"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 35,
    width: 27,
    height: 28,
    fill: "#F75151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarStack);
export default __webpack_public_path__ + "static/media/BarStack.edd818c3f60b083346b421d618f1de70.svg";
export { ForwardRef as ReactComponent };